import React from 'react';
import { InputAdornment } from '@mui/material';
import { SearchOutlined as SearchIcon } from '@mui/icons-material';
import type { SxProps, Theme } from '@mui/material/styles';
import type { TextFieldProps } from '@mui/material/TextField';
import { ListPageFilterTextField, ListPageFilterSearchContainer } from './listPageFilter.styles';

export interface ListPageMainSearchFieldProps extends Omit<TextFieldProps, 'variant' | 'size'> {
  /** Por defecto vacío en listados unificados (sin hint dentro del input). */
  placeholder?: string;
  label: string;
  /** Preferir ancho por defecto; usar solo si un menú lo exige de forma excepcional. */
  containerSx?: SxProps<Theme>;
}

/**
 * Campo de búsqueda principal unificado: mismo TextField, lupa y adornos que catálogo/inventario.
 */
const ListPageMainSearchField: React.FC<ListPageMainSearchFieldProps> = ({
  placeholder = '',
  label,
  InputProps,
  InputLabelProps,
  containerSx,
  ...rest
}) => (
  <ListPageFilterSearchContainer sx={containerSx}>
    <ListPageFilterTextField
      fullWidth
      variant="outlined"
      size="medium"
      label={label}
      placeholder={placeholder}
      InputLabelProps={{ shrink: true, ...InputLabelProps }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ color: 'text.secondary', mr: 1 }} />
          </InputAdornment>
        ),
        ...InputProps,
      }}
      {...rest}
    />
  </ListPageFilterSearchContainer>
);

export default ListPageMainSearchField;
